<template>
  <section>
    <section
      class="column"
      :class="{ removeTopPadding: !box.showIconImage && !box.showBgImage, extraTopPadding: box.showBgImage }"
      :style="{ 
        backgroundColor: box.showBgImage ? 'initial' : box.boxColor,
        color: box.boxText 
      }"
    >
      <img class="box-image" :src="box.backgroundImage.replace('desktop', 'mobile').replace('desktop-1000', 'mobile-375')" :style="{opacity: bgImageTransparency }" v-if="box.showBgImage">
      <div
        class="wrapCenter"
        @click="
          routerPush(
            box.pageName,
            box.page,
            !box.title ? box.text : box.title,
            box.showButton
          )
        "
      >
        <div class="box-header">
          <div v-if="box.showIconImage && !box.showBgImage" class="iconImageBox">
            <img v-bind:src="box.iconImage" />
          </div>
          <v-icon
            v-else-if="box.showIcon && !box.showBgImage"
            class="iconBox"
            v-bind:color="box.iconColor"
            v-bind:name="box.icon"
            scale="3"
          ></v-icon>
          <h4 class="box-title" :style="customFont">
            {{ box.titles[localLanguageTypesIndex] }}
          </h4>
        </div>
        <div class="box-content" :style="customFont">
          {{ box.texts[localLanguageTypesIndex] }}
        </div>
        <div class="box-content" :style="customFont">
          {{ box.textsTwo[localLanguageTypesIndex] }}
        </div>
        <div v-if="box.showButton" class="box-footer">
          <button
            :style="{ 
              backgroundColor: box.btncolor,
              color: box.btntext,
              ...customFont
            }"
            class="gbBtn"
          >
            <span>{{ box.buttonTitles[localLanguageTypesIndex] }}</span>
          </button>
        </div>
      </div>
    </section>
    <transition name="fadeIn">
      <GuestbookPageModal
        v-if="isActive"
        :pageId="getPageId"
        :activeLanguageIndex="localLanguageTypesIndex"
        @closeModal="handleCloseModal"
      />
    </transition>
  </section>
</template>

<script>
import bus from "@/bus.js";
import GuestbookPageModal from "../GuestbookPageModal";
import { trackBehavior } from "../../callables";
import getCurrentLanguageIndexMixin from "@/mixins/getCurrentLanguageIndexMixin";
import cookieMixin from "@/mixins/cookieMixin";
import newLanguageTypesFormatMixin from '@/mixins/newLanguageTypesFormatMixin';

export default {
  mixins: [
    cookieMixin,
    getCurrentLanguageIndexMixin,
    newLanguageTypesFormatMixin
  ],
  props: {
    box: Object,
    cookieExists: [String],
    secondLang: Boolean,
    activeLanguage: String,
    customFonts: Object,
  },
  components: {
    GuestbookPageModal,
  },
  computed: {
    customFont() {
      return this.customFonts.customFonts ? {'font-family': this.customFonts.customFontCss } : {};
    },
    getPageId() {
      return this.box.page.split("/")[3];
    },
    bgImageTransparency() {
      return Number((this.box.bgTransparency ? this.box.bgTransparency : '100')) / 100;
    },
  },
  data() {
    return {
      activeGuestTemp: "",
      isActive: false,
      localLanguageTypesIndex: 0,
    };
  },
  // acts like window.onhashchange but allows multiple instances
  watch: {
    $route: function () {
      if (window.location.hash == "") {
        this.handleCloseModal();
      }
    },
  },
  async created() {
    this.activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
    this.localLanguageTypesIndex = await this._getCurrentLanguageIndex(this.$customerId, this.getCookie('activeLanguage'));
  },
  methods: {
    handleCloseModal: function () {
      window.location.hash = "";
      this.isActive = false;
      bus.$emit("bodyOverflow", false);
    },
    openModal: function () {
      window.location.hash = "browsinPage";
      this.isActive = true;
      bus.$emit("bodyOverflow", true);
    },
    routerPush: async function (
      type,
      data,
      titleText,
      isBtnPresent
    ) {
      if (!isBtnPresent) {
        return;
      }
      if (!titleText) {
        titleText = "NO TITLE WAS GIVEN";
      }

      trackBehavior({
        action: "click",
        clickedInfo: titleText,
        guestID: this.activeGuestTemp,
        eventID: this.$hotelId,
        customerID: this.$customerId,
      });

      if (type === "Costum-link") {
        let data = this.box.httpLinks[this.localLanguageTypesIndex]
        if (!data.includes('http')) {
          data = 'https://' + data;
        }
        window.open(`${data}`, "_blank");        
      } else if (type === "file") {
        window.open(`${data}`, "_blank");
      } else if (type == "mobilePhone") {
        window.open(`tel:${data}`, "_self");
      } else if (type == "emailAddress") {
        window.open(`mailto:${data}`, "_self");
      } else if (data.includes("/pages/")) {
        this.openModal();
      } else {
        this.$router.push(data);
      }
    },
  },
};
</script>
<style scoped>
.column {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 240px;
  padding-top: 12px;
  padding-bottom: 0px;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.box-title-custom {
  margin-top: 10px;
  margin-bottom: 5px;
  display: block;
  font-size: 2.5em;
  line-height: 1;
}

.iconImageBox {
  height: 70px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 5px;
}
.iconImageBox > img {
  max-height: 100%;
  max-width: 100%;
}
.iconBox {
  height: 70px;
  overflow: hidden;
  margin-top: 8px;
}

.box-footer {
  margin-top: auto;
  border-radius: 8px;
  min-height: 58px;
}

.box-title {
  font-size: 1.25rem;
  font-weight: 500; /* Medium */
  margin-top: auto;
  margin-bottom: auto;
  min-height: 30px;
  display: flex;
  justify-content: center;
}

.wrapCenter {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  z-index: 3;
}
.box-image {
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  border-radius: 8px;
}
.removeTopPadding {
  padding-top: 0px;
}
.extraTopPadding {
  padding-top: 80px;
}
.iconBox {
  height: 70px;
  overflow: hidden;
  margin-top: 8px;
}
.gbBtn {
  height: 45px;
  padding: 0px 9px;
  margin-bottom: 13px;
  border: 2px solid transparent;
  width: calc(100% - 26px);
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
  overflow-x: hidden;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  cursor: pointer;
}
</style>
